import LeftMenuNavSection from "components/LeftMenuNavSection";
import WarehousePicker from "./WarehousePicker.jsx";
import CurrencyPicker from "./CurrencyPicker.jsx";
import ProjectDetailsSection from "./ProjectDetailsSection.jsx";
import ProjectLogoSection from "./logoSection/ProjectLogoSection.jsx";

const LeftMenu = ({ onMenuClose, project, onSelectEditDetails, readOnly }) => {
  return (
    <div className="grid h-full w-full grid-rows-[auto_1fr] overflow-y-hidden">
      <div>
        <LeftMenuNavSection
          location={{
            name: "Projects",
            url: "/private/projects",
            direction: "left",
          }}
        />
      </div>
      <div className="flex h-full flex-col gap-5 overflow-y-scroll pt-5">
        <div className="px-2">
          <ProjectLogoSection project={project} readOnly={readOnly} />
        </div>
        <div className="px-2">
          <ProjectDetailsSection
            project={project}
            onSelectEditDetails={onSelectEditDetails}
            readOnly={readOnly}
          />
        </div>
        <div className="px-2">
          <WarehousePicker
            projID={project?.id}
            selectedWarehouses={project?.warehouses}
            readOnly={readOnly}
          />
        </div>
        <div className="px-2">
          <CurrencyPicker
            projID={project?.id}
            selectedCurrency={project?.currency}
            readOnly={readOnly}
          />
        </div>
      </div>
    </div>
  );
};

export default LeftMenu;
